import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { DMButton, DMDiv, DMText } from './Primitives';

export type DigitalMarketingBreadcrumbItem = {
  label: string;
  path?: string;
  onClick?: () => void;
};

type DigitalMarketingBreadcrumbProps = {
  items?: DigitalMarketingBreadcrumbItem[];
  className?: string;
  includeBaseItems?: boolean;
};

export const DIGITAL_MARKETING_BREADCRUMB_BASE_ITEMS: DigitalMarketingBreadcrumbItem[] =
  [
    { label: 'Dashboard Selection', path: '/digital-marketing' },
    {
      label: 'Digital Marketing Dashboard',
      path: '/digital-marketing/dashboard',
    },
  ];

export function DigitalMarketingBreadcrumb({
  items = [],
  className = '',
  includeBaseItems = true,
}: DigitalMarketingBreadcrumbProps) {
  const navigate = useNavigate();
  const breadcrumbItems = includeBaseItems
    ? [...DIGITAL_MARKETING_BREADCRUMB_BASE_ITEMS, ...items]
    : items;

  if (!breadcrumbItems.length) {
    return null;
  }

  return (
    <DMDiv
      as="nav"
      aria-label="Breadcrumb"
      className={`flex flex-wrap items-center gap-[0.55vw] text-[1.65vh] font-medium leading-none text-gray-500 ${className}`}
    >
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;
        const canNavigate = (item.path || item.onClick) && !isLast;

        return (
          <React.Fragment key={`${item.label}-${item.path || index}`}>
            {canNavigate ? (
              <DMButton
                type="button"
                onClick={() => {
                  if (item.onClick) {
                    item.onClick();
                    return;
                  }

                  if (item.path) {
                    navigate(item.path);
                  }
                }}
                className="text-gray-500 transition-colors hover:text-primary-main hover:underline"
              >
                {item.label}
              </DMButton>
            ) : (
              <DMText
                as="span"
                className={
                  isLast ? 'font-semibold text-primary-main' : 'text-gray-500'
                }
              >
                {item.label}
              </DMText>
            )}
            {!isLast && (
              <DMText as="span" className="text-gray-400">
                /
              </DMText>
            )}
          </React.Fragment>
        );
      })}
    </DMDiv>
  );
}
